import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

// CSS Import
import "./index.css";

// SVG Import

// EMAIL Import
import emailjs from "@emailjs/browser";

// REDUX Import
import { toast_position } from "../../../../redux/features/Settings/Authorization";

// COMPONENTS Import
import Footer from "../../../../components/LandingPage/Footer";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";

const BookDemo = () => {
  // useRef
  const emailRef = useRef();
  const contactRef = useRef();
  const fullNameRef = useRef();
  const companyNameRef = useRef();
  const requirementRef = useRef();

  // useState
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [contact, setContact] = useState("");
  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [requirement, setRequirement] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(null);
  const [isValidContact, setIsValidContact] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]+$/;

  // useSelector
  const { mobilestatus, webstatus } = useSelector(
    (state) => state.landingpagestate,
  );

  // useEffect
  useEffect(() => {
    emailjs.init("BYAIWqAyYJKmVXOHA");
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!/^\d{10}$/.test(contact)) {
      newErrors.contact =
        "Please enter a valid 10-digit contact number with +91.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEmailChange = (e) => {
    let emailValue = e.target.value.replace(/\s/g, "").toLowerCase();
    setEmail(emailValue);
    if (emailValue === "") {
      setIsValidEmail(null);
      toast.dismiss();
    } else if (emailRegex.test(emailValue)) {
      setIsValidEmail(true);
      toast.dismiss();
    } else {
      setIsValidEmail(false);
    }
  };

  const handleInputChange = (e) => {
    let contactNumber = e.target.value;
    if (/^\d{0,10}$/.test(contactNumber)) {
      setContact(contactNumber);
    }
    if (
      contactNumber.length > 0 &&
      contactNumber.length === 10 &&
      /^\d{0,10}$/.test(contactNumber)
    ) {
      setIsValidContact(true);
      toast.dismiss();
    } else {
      setIsValidContact(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const serviceId = "service_bt8vaud";
    const templateId = "template_qkqs9w6";
    try {
      await emailjs.send(serviceId, templateId, {
        fullName: fullNameRef.current.value,
        email: emailRef.current.value,
        contact: contactRef.current.value,
        companyName: companyNameRef.current.value,
        requirement: requirementRef.current.value,
      });
      CommonToast({
        text: "Your request has been submitted successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      setFullName("");
      setEmail("");
      setContact("");
      setCompanyName("");
      setRequirement("");
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  const handleInvalidIconClick = (type) => {
    let message;
    switch (type) {
      case "email":
        if (!isValidEmail) {
          message = "The email you entered is invalid.";
        }
        break;
      case "contact":
        if (!isValidContact) {
          message = "The contact number you entered is invalid.";
        }
        break;
      default:
        console.error("Invalid type passed :", type);
        return;
    }
    if (message) {
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === " " || e.code === "Space") {
      e.preventDefault();
    }
  };
  const buttonDisabled =
    !fullName.trim() ||
    !email.trim() ||
    !contact.trim() ||
    !companyName.trim() ||
    !requirement.trim() ||
    !emailRegex.test(email.trim()) ||
    !/^\d{10}$/.test(contact.trim());

  return (
    <>
      <div>
        {isMobile ? (
          <div>
            <div
              style={{
                overflowY: mobilestatus ? "hidden" : "auto",
                height: "100vh",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                WebkitOverflowScrolling: "touch",
              }}
              className="bg-[#031f4f]"
            >
              <div className="px-[30px] py-[30px] mt-[60px] flex flex-col gap-2.5 text-text-primary bg-[#1D3A6D]">
                <div className="h-full max-w-[1440px] w-full flex justify-center mx-auto">
                  <div className="w-full md:w-[80%] lg:w-[50%] flex flex-col justify-center px-4 lg:pl-[125px]">
                    <h3 className="text-base font-semibold text-text-primary">
                      Request a <span className="text-pending">demo</span>
                    </h3>
                    <div className="rounded-2xl md:p-6">
                      <form
                        className="mt-5"
                        onSubmit={handleSubmit}
                      >
                        <p className="text-[#DADADA] text-sm font-semibold">
                          Request a personalised demo to explore how it can
                          streamline your operations!
                        </p>
                        <div className="grid grid-cols-1 gap-x-6 gap-y-3 md:gap-y-8 md:grid-cols-2 mt-4">
                          <div className="w-full">
                            <label
                              htmlFor="fullName"
                              className="text-xs font-medium leading-6 text-text-primary"
                            >
                              Full name
                            </label>
                            <input
                              style={{
                                caretColor: "var(--text-primary)",
                              }}
                              ref={fullNameRef}
                              id="fullName"
                              name="fullName"
                              type="text"
                              value={fullName}
                              onChange={(e) => setFullName(e.target.value)}
                              placeholder="Enter your name"
                              className="custom-autofill block w-full rounded-md border border-[#DADADA] bg-transparent py-1.5 px-2.5 text-xs placeholder:text-xs text-[#DADADA]"
                            />
                          </div>

                          <div className="w-full">
                            <label
                              htmlFor="email"
                              className={`text-xs font-medium leading-6 text-[#DADADA]`}
                            >
                              Email ID
                            </label>
                            <div
                              className={`flex justify-between rounded-md border py-1.5 px-2.5 border-[#DADADA]`}
                            >
                              <input
                                style={{
                                  caretColor: "var(--text-primary)",
                                }}
                                ref={emailRef}
                                id="email"
                                name="email"
                                type="email"
                                value={email}
                                onKeyDown={handleKeyDown}
                                onChange={handleEmailChange}
                                placeholder="Enter your email ID"
                                className="custom-autofill block w-full bg-transparent text-xs placeholder:text-xs text-[#DADADA]"
                              />
                              {isValidEmail !== null && !isValidEmail && (
                                <img
                                  src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                                  alt="Invalid"
                                  className="w-[16px] h-[16px] ml-[10px] cursor-pointer"
                                  onClick={() =>
                                    handleInvalidIconClick("email")
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:gap-y-8 md:grid-cols-2 mt-2">
                          <div className="w-full">
                            <label
                              htmlFor="contact"
                              className={`text-xs font-medium leading-6 text-text-primary`}
                            >
                              Contact number
                            </label>
                            <div
                              className={`flex justify-between rounded-md border py-1.5 px-2.5 border-[#DADADA]`}
                            >
                              <p className="text-xs placeholder:text-base text-[#DADADA] mr-[2px]">
                                +91{" "}
                              </p>
                              <input
                                style={{
                                  caretColor: "var(--text-primary)",
                                }}
                                ref={contactRef}
                                id="contact"
                                name="contact"
                                type="text"
                                max={10}
                                value={contact}
                                onChange={handleInputChange}
                                placeholder="Enter your contact number"
                                className="custom-autofill block w-full bg-transparent text-xs placeholder:text-xs text-[#DADADA]"
                              />
                              {contact.length < 10 && contact.length > 0 && (
                                <img
                                  src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                                  alt="Invalid"
                                  className="w-[16px] h-[16px] cursor-pointer"
                                  onClick={() =>
                                    handleInvalidIconClick("contact")
                                  }
                                />
                              )}
                            </div>
                          </div>

                          <div className="w-full">
                            <label
                              htmlFor="companyName"
                              className="text-xs font-medium leading-6 text-text-primary"
                            >
                              Company name
                            </label>
                            <input
                              style={{
                                caretColor: "var(--text-primary)",
                              }}
                              ref={companyNameRef}
                              id="companyName"
                              name="companyName"
                              type="text"
                              value={companyName}
                              onChange={(e) => setCompanyName(e.target.value)}
                              placeholder="Enter your company's name"
                              className="custom-autofill block w-full rounded-md border border-[#DADADA] bg-transparent py-1.5 px-2.5 text-xs placeholder:text-xs text-[#DADADA]"
                            />
                          </div>
                        </div>

                        <div className="w-full mt-2">
                          <label
                            htmlFor="requirement"
                            className="text-xs font-medium leading-6 text-text-primary"
                          >
                            Requirement
                          </label>
                          <textarea
                            style={{
                              caretColor: "var(--text-primary)",
                            }}
                            ref={requirementRef}
                            rows={8}
                            id="requirement"
                            name="requirement"
                            value={requirement}
                            onChange={(e) => setRequirement(e.target.value)}
                            placeholder="Describe your requirement"
                            className="custom-autofill block w-full rounded-md border border-[#DADADA] bg-transparent py-1.5 px-2.5 text-xs placeholder:text-xs text-[#DADADA]"
                          />
                        </div>

                        <div className="mt-6 flex items-center justify-center md:justify-end gap-x-6">
                          <button
                            type="submit"
                            disabled={buttonDisabled}
                            className={`rounded-[50px] px-7 py-2 text-sm font-semibold ${
                              buttonDisabled
                                ? "bg-[#707070] text-[#DADADA] cursor-default"
                                : "bg-text-primary text-[#1D3A6D]  hover:bg-hover-bg-white-dark cursor-pointer"
                            }`}
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
            </div>
          </div>
        ) : (
          <div
            style={{
              overflow: webstatus ? "hidden" : "",
              minHeight: "100vh",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              WebkitOverflowScrolling: "touch",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="flex-1 flex justify-center items-center mt-[30px] pb-[30px] bg-[#1D3A6D]">
              <div className="h-full max-w-[1440px] w-full flex justify-center mx-auto flex-1">
                <div className="w-[50%] flex flex-col justify-center">
                  <h3 className="text-center pt-[60px] pb-5 text-font-xl font-semibold text-text-primary">
                    Request a <span className="text-pending">demo</span>
                  </h3>
                  <div className="bg-[#314D7E] rounded-2xl">
                    <form
                      className="p-5 mt-1"
                      onSubmit={handleSubmit}
                    >
                      <p className="text-[#DADADA] text-sm font-semibold">
                        Request a personalised demo to explore how it can
                        streamline your operations!
                      </p>
                      <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2 mt-4">
                        <div className="w-full">
                          <label
                            htmlFor="fullName"
                            className="block text-font-xxs font-medium leading-6 text-[#DADADA]"
                          >
                            Full name
                          </label>
                          <input
                            ref={fullNameRef}
                            id="fullName"
                            name="fullName"
                            type="text"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            placeholder="Enter your name"
                            className="block w-full rounded-md border border-[#DADADA] bg-transparent py-1.5 px-2.5 text-xs placeholder:text-xs text-[#DADADA]"
                          />
                        </div>
                        <div className="w-full">
                          <label
                            htmlFor="email"
                            className={`block text-font-xxs font-medium leading-6 text-[#DADADA]`}
                          >
                            Email ID
                          </label>
                          <div
                            className={`flex justify-between rounded-md border py-1.5 px-2.5 border-[#DADADA]`}
                          >
                            <input
                              ref={emailRef}
                              id="email"
                              name="email"
                              type="text"
                              value={email}
                              onKeyDown={handleKeyDown}
                              onChange={handleEmailChange}
                              placeholder="Enter your email ID"
                              className="block w-full bg-transparent text-xs placeholder:text-xs text-[#DADADA]"
                            />
                            {isValidEmail !== null && !isValidEmail && (
                              <img
                                src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                                alt="Invalid"
                                className="w-[16px] h-[16px] ml-[10px] cursor-pointer"
                                onClick={() => handleInvalidIconClick("email")}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2 mt-2">
                        <div className="w-full">
                          <label
                            htmlFor="contact"
                            className="block text-font-xxs font-medium leading-6 text-[#DADADA]"
                          >
                            Contact number
                          </label>
                          <div className="flex justify-between rounded-md border py-1.5 px-2.5 border-[#DADADA]">
                            <p className="bg-transparent text-xs placeholder:text-xs text-[#DADADA] mr-[2px]">
                              +91{" "}
                            </p>
                            <input
                              ref={contactRef}
                              id="contact"
                              name="contact"
                              type="text"
                              value={contact}
                              max={10}
                              onChange={handleInputChange}
                              placeholder="Enter your contact number"
                              className="block w-full bg-transparent text-xs placeholder:text-xs text-[#DADADA]"
                            />
                            {contact.length < 10 && contact.length > 0 && (
                              <img
                                src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                                alt="Invalid"
                                className="w-[16px] h-[16px] cursor-pointer"
                                onClick={() =>
                                  handleInvalidIconClick("contact")
                                }
                              />
                            )}
                          </div>
                        </div>

                        <div className="w-full">
                          <label
                            htmlFor="companyName"
                            className="block text-font-xxs font-medium leading-6 text-[#DADADA]"
                          >
                            Company name
                          </label>
                          <input
                            ref={companyNameRef}
                            id="companyName"
                            name="companyName"
                            type="text"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                            placeholder="Enter your company's name"
                            className="block w-full rounded-md border border-[#DADADA] bg-transparent py-1.5 px-2.5 text-xs placeholder:text-xs text-[#DADADA]"
                          />
                        </div>
                      </div>

                      <div className="w-full mt-2">
                        <label
                          htmlFor="requirement"
                          className="block text-font-xxs font-medium leading-6 text-[#DADADA]"
                        >
                          Requirement
                        </label>
                        <textarea
                          rows={8}
                          ref={requirementRef}
                          id="requirement"
                          name="requirement"
                          type="text"
                          value={requirement}
                          onChange={(e) => setRequirement(e.target.value)}
                          placeholder="Describe your requirement"
                          className="block w-full rounded-md border border-[#DADADA] bg-transparent py-1.5 px-2.5 text-xs placeholder:text-xs text-[#DADADA]"
                        />
                      </div>
                      <div className="mt-6 flex items-center justify-end gap-x-6">
                        <button
                          type="submit"
                          disabled={buttonDisabled}
                          // onClick={handleSubmit}
                          className={`rounded-[50px] px-7 py-2 text-sm font-semibold ${
                            buttonDisabled
                              ? "bg-[#707070] text-[#DADADA] cursor-default"
                              : "bg-text-primary text-[#1D3A6D] hover:bg-hover-bg-white-dark cursor-pointer"
                          }`}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        )}
      </div>
    </>
  );
};

export default BookDemo;
